import { useCallback } from "react";
import { UpdateAttribute } from "../../../../hooks/attributes/useAttributes";
import { TableAttribute } from "../components/Table/TableAttributeItem";

export const useTableAttributeUpdate = (
  id: string,
  updateAttribute: UpdateAttribute<TableAttribute>,
  deleteAttribute: (id: string) => void,
) => {
  const updateName = useCallback(
    e => {
      const { value } = e.target;

      updateAttribute(id, { name: value });
    },
    [id, updateAttribute],
  );
  const updateType = useCallback(
    val => {
      updateAttribute(id, { type: val[0].value });
    },
    [id, updateAttribute],
  );
  const toggleIndex = useCallback(
    hasIndex => {
      updateAttribute(id, { hasIndex });
    },
    [id, updateAttribute],
  );
  const deleteTableAttribute = useCallback(() => deleteAttribute(id), [deleteAttribute, id]);

  return { updateName, updateType, toggleIndex, deleteTableAttribute };
};
